<template>
	<div ref="scrollContainer" id="page-po" >
    <resize-observer @notify="__resizeHanlder" />
		<div class="customer-top-nav no-print">
			<div class="title" v-if="inventory != null">
				<span>{{inventory.name}}</span> - {{$t('purchase_orders.purchase_orders_list')}}<br>
				<span style="font-size:14px;">{{inventory.description}}</span>
			</div>
			<div class="controls">
				<el-radio-group v-model="modeModel" class="hidden-sm-and-down" size="small">
					<el-radio-button label="list" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-list" style="font-size:12px;"></i></el-radio-button>
					<el-radio-button label="tile" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-grid" style="font-size:12px;"></i></el-radio-button>
				</el-radio-group>
				<el-button type="primary" @click="openPODialog" size="small" :disabled="!$can('manage', 'PurchaseOrders')"><i class="mdi mdi-plus-circle"><span style="padding-left:5px;">{{$t('common.New')}}</span></i> </el-button>
			</div>
		</div>
    <el-row>
      <el-col :span="poListSpan"  >
        <PurchaseOrdersList @select="selectPO" :inventoryId="inventoryId" @inventory-change="closePO"></PurchaseOrdersList>
      </el-col>
      <el-col :span="poDetailSpan"  v-if="showPo" style="padding-left:10px;">
        <PurchaseOrder :po="selectedPurchaseOrder" :height="pageHeight" @deleted="closePO" @close="closePO" @editPurchaseOrder="editPo" @duplicate="handleDuplication" :inventory="inventory"></PurchaseOrder>
      </el-col>
    </el-row>
    <PurchaseOrderDialog :dialogVisible.sync="poDialogVisible" :inventoryId="inventoryId" :editSelectedPurchaseOrder="editSelectedPurchaseOrder" @close="closePODialog"></PurchaseOrderDialog>
	</div>
</template>

<script>
import PurchaseOrderDialog from './components/purchase-order-dialog.vue'
import PurchaseOrder from './components/purchase-order.vue'
import PurchaseOrdersList from './components/purchase-orders-list'
import { EventBus } from '@/core/event-bus'

import { mapActions, mapState, mapGetters } from 'vuex';


export default {
  data() {
    return {
      fullScreenLoading : true,
      poListSpan : 24,
      pageWidth : 0,
			pageHeight : 0,
      poDetailSpan:0,
      showPo:false,
      search : '',
			lastUpdatedProducts : [],
			lastUpdatedPO : [],
			stats : {},
			poDialogVisible : false,
			editSelectedPurchaseOrder:false,
    };
  },components: {
		PurchaseOrdersList,
    PurchaseOrderDialog,
    PurchaseOrder
  },
	methods: {

    close(){
			this.$router.go(-1);
		},
    selectPO(po,index){
			this.setSelectedPurchaseOrder({index:index,selectedPurchaseOrder:po})

      if(this.pageWidth<1054){
        this.poListSpan=0;
        this.poDetailSpan = 24;
      }else{
        this.poListSpan=8;
        this.poDetailSpan=16;
      }
      this.showPo=true;
    },
    closePO(){
      this.poDetailSpan=0;
      this.poListSpan=24;
      this.showPo=false;
    },
		openPODialog(){
			this.poDialogVisible=true;
		},
		handleDuplication(po){
			this.duplicate(po);
			this.openPODialog();
		},
		editPo(po){
			let poToEdit = _.cloneDeep(po);
			_.forEach(poToEdit.lines, line => {
				if (line.fk_product_item_id != null) {
					line.productItem = { id: line.fk_product_item_id }
				}
			})
			this.setPurchaseOrder({ purchaseOrder: poToEdit, products: this.selectedPurchaseOrderProducts, productItems: this.selectedPurchaseOrderProductItems })
      this.editSelectedPurchaseOrder=true;
      this.openPODialog();
		},
    closePODialog(){
      this.poDialogVisible=false;
      this.editSelectedPurchaseOrder=false;
    },
		setPageWidth() {
			this.pageWidth = document.getElementById('page-po').offsetWidth;
			this.pageHeight = document.getElementById('page-po').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
		...mapActions('purchaseOrders',['initPurchaseOrders','fetchSearchedPurchaseOrders','setSelectedPurchaseOrder','changeMode']),
		...mapActions('purchaseOrderEditor', ['setPurchaseOrder','duplicate']),
    ...mapActions('inventoryProducts', ['fetchInventory'])
	},
	computed: {
		modeModel : {
			get(){ return this.mode},
			set(mode){this.closePO();this.changeMode(mode)}
		},
		inventoryId(){
			return this.$route.params.id;
		},
		...mapState('purchaseOrders',['selectedIndex','selectedPurchaseOrder', 'mode', 'selectedPurchaseOrderProductItems', 'selectedPurchaseOrderProducts']),
    ...mapState('inventoryProducts', ['inventory'])
	},
  mounted(){


  },
	watch:{
		inventoryId : function(val){
			this.initPurchaseOrders({inventoryId:this.inventoryId})
			this.fetchSearchedPurchaseOrders();
			this.fetchInventory(this.inventoryId);
		}
	},
	created(){
		this.initPurchaseOrders({inventoryId:this.inventoryId});
		this.fetchSearchedPurchaseOrders();
		this.fetchInventory(this.inventoryId);
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
